import { h } from '@stencil/core';

export const dataWithChevron = (data: string | number) => {
	const chevron = setChevronDirection(data);
	const icon = chevron ? <i class={`${chevron}`} aria-hidden="true"></i> : null;

	let numericValue: number | null = null;
	if (typeof data === 'number') numericValue = data;
	else if (typeof data === 'string' && data.endsWith('%'))
		numericValue = parseFloat(data.slice(0, -1).replace(',', '.'));
	else if (typeof data === 'string')
		numericValue = parseFloat(data.replace(',', '.'));

	const isUp =
		numericValue !== null && !isNaN(numericValue) && numericValue > 0;
	const isDown =
		numericValue !== null && !isNaN(numericValue) && numericValue < 0;

	return (
		<div class="ds-fund-data">
			<span class="sr-only">{isUp ? 'Up ' : isDown ? 'Down ' : ''}</span>
			{icon} {data}
		</div>
	);
};

export const setChevronDirection = (value: string | number | null) => {
	let numberValue = null;

	if (typeof value === 'number') numberValue = value;
	else if (typeof value === 'string' && value.endsWith('%'))
		numberValue = value.slice(0, -1);
	else if (typeof value === 'string') numberValue = value;

	// Different locales have different decimal symbols, parseFloat works only with ".", not with ","
	if (isNaN(numberValue))
		numberValue = parseFloat(numberValue.replace(',', '.'));

	if (!isNaN(numberValue)) {
		if (numberValue === 0) return null;
		else if (numberValue > 0) return 'fa fa-chevron-up';
		else if (numberValue < 0) return 'fa fa-chevron-down';
	} else return null;
};
